var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-sidebar',{attrs:{"id":"sidebar-vehicle-details","lazy":"","width":_vm.widthSidebar,"visible":_vm.vehicleDetailsSideBar.isShowing,"shadow":"","right":""}},[_c('b-overlay',[_c('VehicleCard',{attrs:{"vehicle":_vm.vehicleDetailsSideBar.data,"is-show-full-info":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }